import { inspectOwnedResource } from "./results";
import { isResourceApplicable } from "./applicability";
import { findConnectors } from "@/pages/admin/Settings/settings.api";
import type { EventConnector } from "@/pages/admin/Settings/settings.api";
import type { ConnectorResourceDefinition, ResourceDriver } from "./types";

export const connectorResourceDriver: ResourceDriver<ConnectorResourceDefinition, "connector"> = {
  kind: "connector",
  setup: "manual",
  collection: {
    scopeId: ({ tenancyId }) => tenancyId,
    load: async (tenancyId) => {
      const response = await findConnectors.submit({ params: { id: tenancyId } });
      const data = response?.data ?? response;
      return Array.isArray(data) ? data : Array.isArray(data?.data) ? data.data : [];
    },
  },
  describe: (declaration) => declaration.resource.name,
  define: (context, owner, declaration) => {
    const resource = declaration.resource;
    return [{
      key: owner.stepId,
      stepId: owner.stepId,
      definitionKey: resource.key,
      kind: "connector",
      label: resource.name,
      applicable: isResourceApplicable(context.answers, owner, resource),
      resource,
    }];
  },
  inspect: (context, definition, resourceId) => {
    const connector = (context.collections?.connector as EventConnector[] | undefined)?.find((candidate) => candidate.id === resourceId);
    const inputs = definition.resource.subscribedEvents.map((event) => ({
      id: event,
      title: event,
      instructions: `Subscribe the connector to ${event}.`,
      complete: Boolean(connector?.subscribedEvents?.includes(event)),
    }));
    inputs.unshift({
      id: "destination",
      title: "Saved destination",
      instructions: "Save a connector with a support destination. The API validates its destination before saving; credentials may be hidden on reads.",
      complete: Boolean(connector),
    });
    return inspectOwnedResource(definition, {
      found: connector,
      inputs,
      messages: {
        missing: "Create or select an event connector for these alerts.",
        incomplete: "Subscribe the connector to the required events.",
        ready: "The connector receives the required events. Test delivery before finishing.",
      },
    });
  },
};
